export default "/shUSDC.9e40b9f0a496e235084500b6802dcf61.svg";